import { createContext } from 'react';

interface EdgeHighlightContextValue {
  hoveredEdgeId: string | null;
}

export const edgeHighlightContext = createContext<EdgeHighlightContextValue>({
  hoveredEdgeId: null,
});
